import React, { useEffect, useState } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const Docs = () => {
    const [docs, setDocs] = useState("");
    useEffect(() => {
        fetch("/public/static/USER_GUIDE.md").then(res => res.text()).then(res => {
            setDocs(res);
        })
    }, []);
    return (
        <Markdown remarkPlugins={[remarkGfm]}>{docs}</Markdown>
    )
}

export default Docs;